import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useFocused, useSelected, useSlateStatic } from "slate-react";
import { Popper } from "../../../../popper/Popper";
import { PopperBox } from "../../../../popper/PopperBox";
import { focusEditor, SLATE_ZERO_WIDTH_SPACE } from "../../utilities/index";
import * as Styled from "./LinkElement.styled";
import { LinkToolbar } from "./LinkToolbar";
import { expandSelectionToLink } from "./link-utilities";
export const LinkElement = ({ attributes, element, children }) => {
    const editor = useSlateStatic();
    const isSelected = useSelected();
    const isFocused = useFocused();
    const isActive = isSelected && isFocused;
    const linkColor = element.children.find((child) => child.color)?.color || undefined;
    if (!children) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx("span", { contentEditable: false, children: SLATE_ZERO_WIDTH_SPACE }), _jsx(Popper, { mode: "popover", placement: "top", onCloseCallback: () => {
                    focusEditor(editor);
                }, trigger: _jsx(Styled.Link, { ...attributes, isActive: isActive, onClick: () => {
                        expandSelectionToLink(editor);
                    }, linkColor: linkColor, children: children }), overlay: _jsx(PopperBox, { maxWidth: "none", borderRadius: "22px", hasPadding: false, hasArrow: true, contentEditable: false, children: _jsx(LinkToolbar, { element: element }) }) }), _jsx("span", { contentEditable: false, children: SLATE_ZERO_WIDTH_SPACE })] }));
};
